import { eventBus } from '../eventbus';


const thrift = require('thrift');

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    // eslint-disable-next-line global-require
    const CategoriesService = require('./js-thrift-api/CategoriesService');
    // eslint-disable-next-line global-require
    const NotesService = require('./js-thrift-api/NotesService');

    // eslint-disable-next-line import/no-unresolved,global-require
    const authtypes = require('./js-thrift-api/auth-api_types');
    // eslint-disable-next-line import/no-unresolved,global-require
    const AuthService = require('./js-thrift-api/AuthService');

    const secureConnectionOptions = {
      transport: thrift.TBufferedTransport,
      protocol: thrift.TJSONProtocol,
      path: '/api/v1/secure',
      // eslint-disable-next-line no-restricted-globals
      https: location.protocol === 'https:',
    };

    const openConnectionOptions = {
      transport: thrift.TBufferedTransport,
      protocol: thrift.TJSONProtocol,
      path: '/api/v1/open',
      // eslint-disable-next-line no-restricted-globals
      https: location.protocol === 'https:',
    };

    const XHRConnectionError = (_status) => {
      if (_status === 0) {
        console.log('Status 0. Network error');
      } else if (_status >= 400) {
        if (_status === 401) {
          eventBus.$emit('unauthorized');
          // store.dispatch(UNAUTHORIZED);
        } else if (_status === 403) {
          eventBus.$emit('unauthorized');
          // store.dispatch(UNAUTHORIZED);
        }
      }
    };
    const checkXHRResponseError = function (respStr) {
      const resp = JSON.parse(respStr);
      const notImplemented = `Function ${resp[1]} not implemented.`;
      const invalidMethod = `Invalid method name: '${resp[1]}'`;
      if (!resp[4][0] && resp[4][1] && (resp[4][1].str === notImplemented
        || resp[4][1].str === invalidMethod)) {
        console.error(`${resp[4][1].str} Check local server`);
        return true;
      }
      return false;
    };

    const bufers = {};

    // eslint-disable-next-line consistent-return
    thrift.XHRConnection.prototype.flush = function () {
      const self = this;
      if (this.url === undefined || this.url === '') {
        return this.send_buf;
      }

      const xreq = this.getXmlHttpRequestObject();

      if (xreq.overrideMimeType) {
        xreq.overrideMimeType('application/json');
      }
      // let useLocalServer = false

      const urlLocalApi = self.url.replace('/api/', /local-api/);
      xreq.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            if (process.env.NODE_ENV === 'development') {
              // console.log(!checkLocalServer, !checkXHRResponseError(this.responseText))
              // let resp = JSON.parse(this.responseText)
              // eslint-disable-next-line no-underscore-dangle
              const _sendBuf = bufers[this.seqid];
              if (_sendBuf && checkXHRResponseError(this.responseText)) {
                xreq.open('POST', urlLocalApi, true);
                // console.log(bufers)
                xreq.send(_sendBuf);
                delete bufers[this.seqid];
              } else {
                self.setRecvBuffer(this.responseText);
                delete bufers[this.seqid];
              }
            } else {
              self.setRecvBuffer(this.responseText);
            }
          } else if (this.status === 404 || this.status >= 500) {
            if (process.env.NODE_ENV === 'development') {
              if (this.responseURL.indexOf('local-api') === -1) {
                xreq.open('POST', urlLocalApi, true);
                xreq.send(bufers[this.seqid]);
              }
            }
          } else {
            XHRConnectionError(this.status);
          }
        }
      };
      xreq.open('POST', this.url, true);
      Object.keys(this.headers).forEach((headerKey) => {
        xreq.setRequestHeader(headerKey, self.headers[headerKey]);
      });
      if (process.env.NODE_ENV === 'development') {
        const sendBuf = JSON.parse(this.send_buf);
        bufers[sendBuf[3]] = this.send_buf;
        // eslint-disable-next-line prefer-destructuring
        xreq.seqid = sendBuf[3];
      }
      // console.log('1', JSON.parse(JSON.stringify(JSON.parse(this.send_buf))))
      // console.log(bufers)
      xreq.send(this.send_buf);
    };

    const mp = new thrift.Multiplexer();
    // eslint-disable-next-line no-restricted-globals,max-len
    const connectionHostName = process.env.THRIFT_HOST ? process.env.THRIFT_HOST : location.hostname;
    // eslint-disable-next-line no-restricted-globals
    const connectionPort = process.env.THRIFT_PORT ? process.env.THRIFT_PORT : location.port;
    const secureConnection = thrift
      .createXHRConnection(connectionHostName, connectionPort, secureConnectionOptions);

    // eslint-disable-next-line max-len,no-undef
    const openConnection = thrift
      .createXHRConnection(connectionHostName, connectionPort, openConnectionOptions);

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$ThriftPlugin = {
      CategoriesService: mp.createClient('categoriesService', CategoriesService, secureConnection),
      NotesService: mp.createClient('notesService', NotesService, secureConnection),
      AuthService: mp.createClient(authtypes.AUTH_SERVICE_NAME, AuthService, openConnection),
      authTypes: authtypes,
    };
  },
};
